// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"hq-z","imageAndVideoCount":"iq-z","imageAndVideoContainer":"jq-z","viewAllReviews":"kq-z"};